import { _ as _slicedToArray } from '../slicedToArray-45a33045.js';
import { _ as _typeof } from '../typeof-64325575.js';
import { ElementParams, PositionNames, ElementTypes, BoxTypes } from '../components/Box/types.js';
import { CSS_UNITS } from '../types/generic.js';
import { THEME_COLOR_PREFIXES, THEME_COLOR_STEPS } from '../types/theme.js';
import '../unsupportedIterableToArray-5baf4325.js';
import '../toConsumableArray-2a885c07.js';
var isObjectWithKeys = function isObjectWithKeys(item) {
  return !!item && _typeof(item) === 'object' && Object.keys(item).length > 0;
};
var isItemWithLabel = function isItemWithLabel(item) {
  return 'label' in item;
};
var isItemWithId = function isItemWithId(item) {
  return 'id' in item;
};
var isItemWithKey = function isItemWithKey(item) {
  return 'key' in item;
};
var isItemWithText = function isItemWithText(item) {
  return 'text' in item;
};
var isItemWithValue = function isItemWithValue(item) {
  return 'value' in item;
};
var isElementArgKey = function isElementArgKey(value) {
  return typeof value === 'string' && ElementParams.includes(value);
};
var isElementArgsRecord = function isElementArgsRecord(value) {
  return !!value && _typeof(value) === 'object' && Object.keys(value).every(isElementArgKey);
};
var isPositionType = function isPositionType(value) {
  return typeof value === 'string' && PositionNames.includes(value);
};
var isElementType = function isElementType(value) {
  return typeof value === 'string' && ElementTypes.includes(value);
};
var isBoxType = function isBoxType(value) {
  return typeof value === 'string' && BoxTypes.includes(value);
};
var isChipValue = function isChipValue(value) {
  if (typeof value === 'string' || typeof value === 'number' || value == null) {
    return true;
  }
  return Array.isArray(value) && value.every(isChipValue);
};
var isObjectEntriesWithLength = function isObjectEntriesWithLength(record, length) {
  return Object.entries(record).length === length;
};
var isSingleEntryArg = function isSingleEntryArg(record) {
  return isObjectEntriesWithLength(record, 1);
};
var isCSSUnit = function isCSSUnit(value) {
  return !!value && typeof value === 'string' && CSS_UNITS.includes(value);
};
var isPercentageUnit = function isPercentageUnit(value) {
  return value === '%';
};
var isRGBstring = function isRGBstring(color) {
  return color.startsWith('rgb(') && color.endsWith(')');
};
var isThemeColorKey = function isThemeColorKey(key) {
  var _key$split = key.split('-'),
    _key$split2 = _slicedToArray(_key$split, 2),
    prefix = _key$split2[0],
    step = _key$split2[1];
  if (!THEME_COLOR_PREFIXES.includes(prefix)) return false;
  return step ? THEME_COLOR_STEPS.includes(Number(step)) : true;
};
var isThemeColorStep = function isThemeColorStep(step) {
  return THEME_COLOR_STEPS.includes(Number(step));
};
export { isBoxType, isCSSUnit, isChipValue, isElementArgKey, isElementArgsRecord, isElementType, isItemWithId, isItemWithKey, isItemWithLabel, isItemWithText, isItemWithValue, isObjectEntriesWithLength, isObjectWithKeys, isPercentageUnit, isPositionType, isRGBstring, isSingleEntryArg, isThemeColorKey, isThemeColorStep };